import { GET_ENC, POST_ENC } from "../common/EncryptedHttp";
import { BASE_URL } from "../common/const";

// Extraocular Uovements
export const GetExtraocularMovementsList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/GetExtraocularMovementsList?` + params, null);

export const GetExtraocularMovementsDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/GetExtraocularMovementsDetail?` + params, null);

export const CreateExtraocularMovements = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/CreateExtraocularMovements`, data);

export const UpdateExtraocularMovements = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/UpdateExtraocularMovements`, data);

export const DeleteExtraocularMovements = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/DeleteExtraocularMovements`, data);

// Pupillary Reaction
export const GetPupillaryReactionList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/GetPupillaryReactionList?` + params, null);

export const GetPupillaryReactionDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/GetPupillaryReactionDetail?` + params, null);

export const CreatePupillaryReaction = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/CreatePupillaryReaction`, data);

export const UpdatePupillaryReaction = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/UpdatePupillaryReaction`, data);

export const DeletePupillaryReaction = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/DeletePupillaryReaction`, data);

// Relative Afferent Pupillary Defect
export const GetRelativeAfferentPupillaryDefectList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/GetRelativeAfferentPupillaryDefectList?` + params, null);

export const GetRelativeAfferentPupillaryDefectDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/GetRelativeAfferentPupillaryDefectDetail?` + params, null);

export const CreateRelativeAfferentPupillaryDefect = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/CreateRelativeAfferentPupillaryDefect`, data);

export const UpdateRelativeAfferentPupillaryDefect = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/UpdateRelativeAfferentPupillaryDefect`, data);

export const DeleteRelativeAfferentPupillaryDefect = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/DeleteRelativeAfferentPupillaryDefect`, data);

// Visual Fields By Confrontation
export const GetVisualFieldsByConfrontationList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/GetVisualFieldsByConfrontationList?` + params, null);

export const GetVisualFieldsByConfrontationDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/GetVisualFieldsByConfrontationDetail?` + params, null);

export const CreateVisualFieldsByConfrontation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/CreateVisualFieldsByConfrontation`, data);

export const UpdateVisualFieldsByConfrontation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/UpdateVisualFieldsByConfrontation`, data);

export const DeleteVisualFieldsByConfrontation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalOccularMotilityAndPupils/DeleteVisualFieldsByConfrontation`, data);
